import React from 'react'

import { ReactComponent as Twitter } from '../../assets/icons/twitter.svg'
import { ReactComponent as Telegram } from '../../assets/icons/telegram.svg'
import { ReactComponent as Discord } from '../../assets/icons/discord.svg'

export const SocialLinks = ({
  className,
  twlink = 'https://twitter.com/CoolCatsTron',
  tgLink = 'https://t.me/TronCoolCatsCN',
  dsLink = 'https://discord.gg/9CwREMEaQ4',
}) => (
  <>
    <a
      href={ twlink }
      target="_blank"
      rel="noopener noreferrer"
      className={ className }
    >
      <Twitter />
    </a>
    <a
      href={ tgLink }
      target="_blank"
      rel="noopener noreferrer"
      className={ className }
    >
      <Telegram />
    </a>
    <a
      href={ dsLink }
      target="_blank"
      rel="noopener noreferrer"
      className={ className }
    >
      <Discord />
    </a>
  </>
)